export default __webpack_public_path__ + "img/icon-flag-es.asset.ba7b2049.jpg";